/**
 * 账号模块 请求 api
 */
// 引入工具函数
import req from '@/utils/request'

// 获取手机验证码
export const phoneCode = (params) => {
  return req.get('/captchaPhone', params)
}

// 系统登录
export const checkLogin = (params) => {
  return req.post('/login', params)
}

// 获取用户信息
export const userInfo = (params) => {
  return req.get('/getInfo', params)
}

// 获取路由信息
export const routerList = (params) => {
  return req.get('/getRouters', params)
}

// 修改密码
export const PasswordModify = (newPassword, oldPassword, userId) => {
  return req.put(`/system/user/updatePassword?newPassword=${newPassword}&oldPassword=${oldPassword}&userId=${userId}`);
}

//获取登录二维码
export const getInQrCode = (params) => {
  return req.get('/getInQrCode', params)
}